import * as React from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  id?: string;
};

const NotFound: React.FC<Props> = ({ id }) => {
  const { t } = useTranslation();

  if (!id) {
    return (
      <div>{t('not_found.no_id')}</div>
    );
  }

  return (
    <div>{t('not_found.no_app_with_id', { id })}</div>
  );
};

export default NotFound;
